import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "styles"
    }}>{`Styles`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "align-content.md"
        }}>{`align-content`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "align-items.md"
        }}>{`align-items`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "align-self.md"
        }}>{`align-self`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background-attachment.md"
        }}>{`background-attachment`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background-color.md"
        }}>{`background-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background-image.md"
        }}>{`background-image`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background-repeat.md"
        }}>{`background-repeat`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background-size.md"
        }}>{`background-size`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "background.md"
        }}>{`background`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom-color.md"
        }}>{`border-bottom-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom-left-radius.md"
        }}>{`border-bottom-left-radius`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom-right-radius.md"
        }}>{`border-bottom-right-radius`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom-style.md"
        }}>{`border-bottom-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom-width.md"
        }}>{`border-bottom-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-bottom.md"
        }}>{`border-bottom`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-color.md"
        }}>{`border-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-left-color.md"
        }}>{`border-left-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-left-style.md"
        }}>{`border-left-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-left-width.md"
        }}>{`border-left-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-left.md"
        }}>{`border-left`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-radius.md"
        }}>{`border-radius`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-right-color.md"
        }}>{`border-right-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-right-style.md"
        }}>{`border-right-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-right-width.md"
        }}>{`border-right-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-right.md"
        }}>{`border-right`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-style.md"
        }}>{`border-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-top-color.md"
        }}>{`border-top-color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-top-left-radius.md"
        }}>{`border-top-left-radius`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-top-style.md"
        }}>{`border-top-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-top-width.md"
        }}>{`border-top-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-top.md"
        }}>{`border-top`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "border-width.md"
        }}>{`border-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "bottom.md"
        }}>{`bottom`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "color.md"
        }}>{`color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "display.md"
        }}>{`display`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex-basis.md"
        }}>{`flex-basis`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex-direction.md"
        }}>{`flex-direction`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex-grow.md"
        }}>{`flex-grow`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex-shrink.md"
        }}>{`flex-shrink`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex-wrap.md"
        }}>{`flex-wrap`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "flex.md"
        }}>{`flex`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "font-family.md"
        }}>{`font-family`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "font-size.md"
        }}>{`font-size`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "font-style.md"
        }}>{`font-style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "font-weight.md"
        }}>{`font-weight`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "height.md"
        }}>{`height`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "justify-content.md"
        }}>{`justify-content`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "left.md"
        }}>{`left`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "letter-spacing.md"
        }}>{`letter-spacing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "margin-bottom.md"
        }}>{`margin-bottom`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "margin-left.md"
        }}>{`margin-left`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "margin-right.md"
        }}>{`margin-right`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "margin-top.md"
        }}>{`margin-top`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "margin.md"
        }}>{`margin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "max-height.md"
        }}>{`max-height`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "max-width.md"
        }}>{`max-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "min-height.md"
        }}>{`min-height`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "min-width.md"
        }}>{`min-width`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "opacity.md"
        }}>{`opacity`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "overflow-x.md"
        }}>{`overflow-x`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "overflow-y.md"
        }}>{`overflow-y`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "overflow.md"
        }}>{`overflow`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "padding-bottom.md"
        }}>{`padding-bottom`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "padding-left.md"
        }}>{`padding-left`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "padding-right.md"
        }}>{`padding-right`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "padding-top.md"
        }}>{`padding-top`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "padding.md"
        }}>{`padding`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "right.md"
        }}>{`right`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "text-align.md"
        }}>{`text-align`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "text-overflow.md"
        }}>{`text-overflow`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "top.md"
        }}>{`top`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "visibility.md"
        }}>{`visibility`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "white-space.md"
        }}>{`white-space`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "width.md"
        }}>{`width`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      